module.exports = __webpack_public_path__ + "static/media/test1 (14).0df7e7ab.jpg";